// extracted by mini-css-extract-plugin
export default {"row":"Insurance_row__l3cdq","fieldName":"Insurance_fieldName__PIkf4","fieldValue":"Insurance_fieldValue__3hLGL"};